<div class="itinerary-model-content-inner">
  <div class="itinerary-model-content">
    <form [formGroup]="itemsForm">
      <div class="ion-no-padding mb-1">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Important Information</ion-title>
      </div>
      <div class="form-container ion-padding-horizontal">
        <div class="row">
          <div class="col">
            <div class="input-container">
              <app-selectable-list-items 
                [addButtonText]="'Add Important Information'"
                formControlName="importantInformation"
                (setDefaultEmitter)="setDefaultLov($event, 'ImportantInformation', 'importantInformation')"
                (removeDefaultEmitter)="removeDefaultLov($event, 'ImportantInformation', 'importantInformation')"
              ></app-selectable-list-items>
            </div>
          </div>
        </div>

        <div class="add-inclusion-main-container">
          <div class="row">
            <div class="col">
              <div class="input-container">
                <label for class="label">Notes</label>
                <div>
                  <app-text-formatting-input formControlName="note"></app-text-formatting-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dashed-line"></div>
    </form>
  </div>

  <div
    class="ion-padding-horizontal bg-light-gray itinerary-model-footer justify-content-center">
    <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()"
      [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified() && storedFormData">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified() && storedFormData">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()"
      [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</div>